import { getButtonSizesMixin, buttonSizes, buttonTypography, buttonViews } from '@salutejs/plasma-core';

/**
 * @private
 */
export var applySizes = /*#__PURE__*/getButtonSizesMixin(buttonSizes, buttonTypography);
/**
 * @private
 */

export var applyViews = function applyViews(_ref) {
  var view = _ref.view;
  return buttonViews[view];
};